import { useEffect } from 'react'

export function useDisableBodyScroll() {
  useEffect(() => {
    document.body.classList.add('overflow-y-hidden')

    return () => {
      document.body.classList.remove('overflow-y-hidden')
    }
  }, [])
}
